import * as React from "react";
import { Button } from "react-ui";

export interface RemoveButtonProps {
    children: JSX.Element;
}

export function RemoveButton(props: RemoveButtonProps): JSX.Element {
    return <Button use="link">{props.children}</Button>;
}
